export default "__VITE_ASSET__C7wwoqc6__"